/* app/ui/map/map.baidu.control */

define(
	'app/ui/map/map.baidu.control',[
		'jquery'
	],
	function ($) {

		var BaiduMapControl;
		var $maps;
		var baiduApiKey = 'BG1rq3BjM60eVFolgi0lv81CBzT9VnjC';//that's NZW's live key. NZW-280

		return {
			init: function ($elms) {
				BaiduMapControl = this;
				$maps = $elms;
				if (typeof BMap != 'undefined' && BMap.Map != 'undefined') {
					BaiduMapControl._processMaps();
				}
				else {
					BaiduMapControl._loadAPI();
				}
			},

			_loadAPI: function () {
				// This code loads the baidu map API code asynchronously.
				var script = document.createElement('script');
				script.type = "text/javascript";
				var firstScriptTag = document.getElementsByTagName('script')[0];
				script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + baiduApiKey +"&callback=null";
				firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

				BaiduMapControl._dependencyCheck();
			},

			_dependencyCheck: function () {
				if (typeof BMap != 'undefined' && typeof BMap.Map != 'undefined') {
					BaiduMapControl._processMaps();
				} else {
					setTimeout(BaiduMapControl._dependencyCheck, 500);
				}
			},

			_processMaps: function () {
				for (var i = 0; i < $maps.length; i++) {
					var mapCanvas = $maps[i];
					var $thisMap = $maps.eq(i);
					var mapStyle = $thisMap.attr('data-map-style');
					var mapZoom = $thisMap.attr('data-map-zoom');
					var mapPin = $thisMap.attr('data-map-pin');
					var locationArray = mapPin.split(',');
					var latitude = parseFloat(locationArray[0]);
					var longitude = parseFloat(locationArray[1]);
					var ggPoint = new BMap.Point(longitude,latitude);
					var map = new BMap.Map(mapCanvas);

					if (mapZoom === undefined || mapZoom === '') {
						mapZoom = 11;
					}
					map.setMapStyle({
						styleJson: [
							  {
          						"featureType": "water",
          						"elementType": "all",
          						"stylers": {
          							"color": "#a3ccff"
          						}
							  }
						]
					});
					map.centerAndZoom(ggPoint, mapZoom);
					map.addControl(new BMap.MapTypeControl({
						mapTypes: [
							BMAP_NORMAL_MAP
						]
					}));
					map.addControl(new BMap.NavigationControl());
					map.enableScrollWheelZoom(true);
					if (window.innerWidth < 767) {
						//baudi map has issue on multi finger move on mobile, have to stop dragging event, or we can not scroll the page
						map.disableDragging();
					}
					//translate google point to baidu point---------------------- start
					translateCallback = function(data) {
						if (data.status === 0) {
							var marker = new BMap.Marker(data.points[0]);
							if (mapStyle !== 'region') {
								map.addOverlay(marker);
							}
							map.setCenter(data.points[0]);
						}
					};

					setTimeout(function () {
						var convertor = new BMap.Convertor();
						var pointArr = [];
						pointArr.push(ggPoint);
						convertor.translate(pointArr, 3, 5, translateCallback);
					}, 1000);
					//translate google point to baidu point---------------------- end
				}
			}
		};
	}
);
